// extracted by mini-css-extract-plugin
export default {"non-ald-part":"_non-ald-part_yeQTYq","ald-part":"_ald-part_q2z4MY","prescription-image":"_prescription-image_4Y5wTJ"};